<template>
    <v-dialog v-model="show" persistent max-width="600" no-click-animation>
        <v-card class="text-center pa-6" rounded="xl">
            <v-icon size="80" color="warning" class="mb-4">mdi-lock-clock</v-icon>
            
            <v-card-title class="text-h5 font-weight-bold justify-center mb-2">
                Seu período de avaliação expirou
            </v-card-title>
            
            <v-card-text class="text-body-1 mb-4">
                <p class="mb-4">
                    Seu trial de 30 dias do <strong>Plano Premium</strong> chegou ao fim.
                    Para continuar utilizando o Amelsy, escolha um dos nossos planos:
                </p>
                
                <v-row class="mb-4">
                    <v-col cols="12" md="6">
                        <v-card outlined class="pa-4" rounded="lg">
                            <v-chip small color="grey" text-color="white" class="mb-2">Starter</v-chip>
                            <div class="text-h5 font-weight-bold primary--text mb-1">R$ 29,90<span class="text-caption grey--text">/mês</span></div>
                            <div class="text-caption grey--text mb-3">Funcionalidades básicas</div>
                            <ul class="text-left text-body-2" style="list-style: none; padding-left: 0;">
                                <li>✅ Até 10 pacientes</li>
                                <li>✅ Até 25 sessões/mês</li>
                                <li>✅ Dashboard e agenda</li>
                            </ul>
                        </v-card>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-card outlined class="pa-4 border-primary" rounded="lg" style="border: 2px solid var(--v-primary-base) !important;">
                            <v-chip small color="primary" text-color="white" class="mb-2">Premium</v-chip>
                            <div class="text-h5 font-weight-bold primary--text mb-1">R$ 169,90<span class="text-caption grey--text">/mês</span></div>
                            <div class="text-caption grey--text mb-3">Tudo ilimitado</div>
                            <ul class="text-left text-body-2" style="list-style: none; padding-left: 0;">
                                <li>✅ Pacientes ilimitados</li>
                                <li>✅ WhatsApp + Google Calendar</li>
                                <li>✅ Gestão completa</li>
                            </ul>
                        </v-card>
                    </v-col>
                </v-row>
            </v-card-text>
            
            <v-card-actions class="justify-center flex-column">
                <v-btn
                    color="primary"
                    large
                    block
                    class="mb-3 rounded-xl"
                    href="https://wa.me/5541997463830?text=Ol%C3%A1%2C%20meu%20trial%20expirou%20e%20gostaria%20de%20assinar%20um%20plano"
                    target="_blank"
                >
                    <v-icon left>mdi-whatsapp</v-icon>
                    Escolher meu plano
                </v-btn>
                <v-btn
                    text
                    small
                    color="grey"
                    @click="logout"
                >
                    Sair da conta
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    name: 'TrialExpiredOverlay',
    
    computed: {
        ...mapGetters('auth', ['isBlocked']),
        
        show() {
            return this.isBlocked;
        }
    },
    
    methods: {
        ...mapActions('auth', ['ActionDoLogout']),
        
        logout() {
            this.ActionDoLogout();
        }
    }
};
</script>
